import { Component, Inject } from '@angular/core';

import { of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { ContextService } from '../../../technical-modules/context/services/context.service';
import { UserService } from '../../../data-domains/humain/user/services/user.service';

// Simple composant destine a exposer le <router-outlet> principal dans la parite AngularJS
// Pourra etre remplace par un simple <router-outlet> quand la structure globale de l'application sera en pur Angular
@Component({
	selector: 'page-content-container',
	templateUrl: 'page-content-container.html',
	// styleUrls: ['page-content-container.css'],
})
export class PageContentContainerComponent {
	constructor(
	) {
	}
}